export default __webpack_public_path__ + "static/media/ranking-leaderboard.1eccb230.png";